module.exports = __webpack_public_path__ + "img/hero-img.9d97c0af.png";